export default (settings_data = null) => {
  try {
    const json = JSON.parse(settings_data);
    if (!json) {
      return null;
    }
    return json.settings;
  } catch (error) {
    console.log('!!! Settings could not parse JSON', error, settings_data);
    return {};
  }
};
